import { User, Preferences } from '../types';

const USER_KEY = 'therapp_user';
const PREFS_KEY = 'therapp_prefs';
const AUTH_KEY = 'therapp_auth';

export const storageMgt = {
  saveUser: (user: User): void => {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },
  getUser: (): User | null => {
    const raw = localStorage.getItem(USER_KEY);
    if (!raw) return null;
    try { return JSON.parse(raw); } catch { return null; }
  },
  clearUser: (): void => {
    localStorage.removeItem(USER_KEY);
  },
  savePrefs: (prefs: Preferences): void => {
    localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
  },
  getPrefs: (): Preferences | null => {
    const raw = localStorage.getItem(PREFS_KEY);
    if (!raw) return null;
    try { return JSON.parse(raw); } catch { return null; }
  },
  clearPrefs: (): void => {
    localStorage.removeItem(PREFS_KEY);
  },
  isAuthenticated: (): boolean => {
    return localStorage.getItem(AUTH_KEY) === 'true';
  },
  setAuthenticated: (val: boolean): void => {
    if (val) localStorage.setItem(AUTH_KEY, 'true');
    else localStorage.removeItem(AUTH_KEY);
  },
  logout: (): void => {
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(PREFS_KEY);
    localStorage.removeItem(AUTH_KEY);
  },
};
